import React from 'react'

import {
  Box,
  Button,
  HStack,
  Switch,
  Center,
  Text,
  Heading,
} from '@chakra-ui/react'

import { ConfirmActionDialog } from '../ui'
import AddContactMethodModal from './AddContactMethodModal'
import ContactMethodTable from './ContactMethodTable'
import {
  useContactMethodsContext,
  ContactMethodsContextProvider,
} from '../../contexts/ContactMethodsContext'
const ManagerInner = () => {
  const {
    openAdd,
    showActiveOnly,
    setShowActiveOnly,
    visibleContactMethods,
    deleteId,
    deleteContactMethod,
    closeDeleteDialog,
    confirmDelete,
    loading,
    contactMethods,
  } = useContactMethodsContext()

  return (
    <Box p={5}>
      <Heading size='md' mb={2}>
        Contact Methods
      </Heading>

      <HStack mb={2} spacing={2}>
        <Button colorScheme='blue' onClick={openAdd}>
          Add New Contact Method
        </Button>
        <HStack ml='auto' align='center'>
          <Text variant='subheading-sm'>Show active contact methods only</Text>
          <Switch
            id='switch-contact-method-active'
            colorScheme='green'
            ml={2}
            isChecked={showActiveOnly}
            onChange={e => setShowActiveOnly(e.target.checked)}
          />
        </HStack>
      </HStack>

      <AddContactMethodModal />

      <Text variant='subheading-gray' paddingTop={2} mb={2}>
        Showing {visibleContactMethods.length} contact methods
      </Text>

      <ContactMethodTable />

      <ConfirmActionDialog
        isOpen={!!deleteId}
        onClose={closeDeleteDialog}
        onConfirm={confirmDelete}
        scheme='delete'
      >
        <b>{deleteContactMethod?.name}</b> will be permanently deleted. Are you
        sure you want to continue?
      </ConfirmActionDialog>

      {loading && (
        <Center my={4}>
          <Text>Loading contact methods...</Text>
        </Center>
      )}

      {!loading && contactMethods.length === 0 && (
        <Center my={4}>
          <Text>No contact methods found.</Text>
        </Center>
      )}
    </Box>
  )
}

const ContactMethodManager = () => (
  <ContactMethodsContextProvider>
    <ManagerInner />
  </ContactMethodsContextProvider>
)

export default ContactMethodManager
